"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaskText = void 0;
var react_1 = __importDefault(require("react"));
var mask_utils_1 = require("./mask.utils");
exports.MaskText = function (props) {
    var RG = props.RG, value = props.value, Number = props.Number, CEP = props.CEP, CNPJ = props.CNPJ, CPF = props.CPF, NoSpace = props.NoSpace, Phone = props.Phone;
    var newVal = '';
    if (RG) {
        newVal = mask_utils_1.RGMask(value);
    }
    if (Number) {
        newVal = mask_utils_1.NumberMask(value);
    }
    if (CEP) {
        newVal = mask_utils_1.CEPMask(value);
    }
    if (CNPJ) {
        newVal = mask_utils_1.CNPJMask(value);
    }
    if (CPF) {
        newVal = mask_utils_1.CPFMask(value);
    }
    if (NoSpace) {
        newVal = mask_utils_1.NoSpaceMask(value);
    }
    if (Phone) {
        newVal = mask_utils_1.PhoneMask(value);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, newVal);
};
//# sourceMappingURL=MaskText.js.map